import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-map-subway',
  templateUrl: './map-subway.component.html',
  styleUrls: ['./map-subway.component.scss']
})
export class MapSubwayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
